export default "__VITE_ASSET__BRb5Su6B__"